var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2144_42488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2144_42488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0019 15.5769C13.1349 15.5769 14.0973 15.1803 14.889 14.3871C15.6807 13.5939 16.0765 12.6308 16.0765 11.4977C16.0765 10.3646 15.6799 9.40224 14.8867 8.61058C14.0936 7.81891 13.1304 7.42308 11.9973 7.42308C10.8642 7.42308 9.90185 7.81966 9.11019 8.61282C8.31852 9.40601 7.92269 10.3692 7.92269 11.5023C7.92269 12.6353 8.31927 13.5977 9.11244 14.3894C9.90562 15.181 10.8688 15.5769 12.0019 15.5769ZM11.9996 14.2C11.2496 14.2 10.6121 13.9375 10.0871 13.4125C9.56209 12.8875 9.29959 12.25 9.29959 11.5C9.29959 10.75 9.56209 10.1125 10.0871 9.58748C10.6121 9.06248 11.2496 8.79998 11.9996 8.79998C12.7496 8.79998 13.3871 9.06248 13.9121 9.58748C14.4371 10.1125 14.6996 10.75 14.6996 11.5C14.6996 12.25 14.4371 12.8875 13.9121 13.4125C13.3871 13.9375 12.7496 14.2 11.9996 14.2ZM12.001 18.5C9.70134 18.5 7.60602 17.8657 5.71499 16.5971C3.82397 15.3285 2.43167 13.6295 1.53809 11.5C2.43167 9.37049 3.82352 7.67146 5.71364 6.40288C7.60374 5.13429 9.6986 4.5 11.9982 4.5C14.2978 4.5 16.3932 5.13429 18.2842 6.40288C20.1752 7.67146 21.5675 9.37049 22.4611 11.5C21.5675 13.6295 20.1757 15.3285 18.2855 16.5971C16.3954 17.8657 14.3006 18.5 12.001 18.5ZM11.9996 17C13.8829 17 15.6121 16.5041 17.1871 15.5125C18.7621 14.5208 19.9663 13.1833 20.7996 11.5C19.9663 9.81664 18.7621 8.47914 17.1871 7.48748C15.6121 6.49581 13.8829 5.99998 11.9996 5.99998C10.1163 5.99998 8.38709 6.49581 6.81209 7.48748C5.23709 8.47914 4.03292 9.81664 3.19959 11.5C4.03292 13.1833 5.23709 14.5208 6.81209 15.5125C8.38709 16.5041 10.1163 17 11.9996 17Z",
    fill: "#505050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.247d7ab53b270664c614cacf0b745c05.svg";
export { ForwardRef as ReactComponent };